export default "__VITE_ASSET__bc1e8f5d__"